import { useContext } from 'react';

import { AppContext } from '../AppProvider';

/**
 * Returns context reference from AppContext. Should be used for pages and main menu.
 * @param {*} id The testID
 * @returns Context reference if found for that id, otherwise null
 */
export const useVideoNodePortal = () => {
  // Takes in testID and returns a global reference
  const [appContext] = useContext(AppContext) || [];

  return appContext?.liveVideoNode;
};
